import {useFetchProfile} from "../../api/signcard";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import ProfileInfoEdit from "./component/profile-info-edit";
import ContactEdit from "./component/contact-edit";
import {ImageCropper} from "./component/image-crop";
import {useProfileUpdater} from "./domain/profile-updater";
import {ProfileStatus} from "../profile/domain/profile-state";

export const ContactChangeStatus = {
    ADD: "ADD",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    NONE: "NONE"
}
export const ProfileEditPage = () => {
    const {link} = useParams();
    const navigate = useNavigate();

    const [isLoading, fetchProfile, error] = useFetchProfile(link)
    const [profileUpdater, contactsUpdater, isChanged, buildFormData] = useProfileUpdater(fetchProfile)

    const [selectedServiceType, setSelectedServiceType] = useState(null) // serviceType
    const [tempProfileImgPath, setTempProfileImgPath] = useState(null)

    useEffect(() => {
        if (fetchProfile == null) return

        if (fetchProfile.status === ProfileStatus.GUEST) {
            navigate("/not-found")
        }
    }, [fetchProfile, navigate])

    const resetTempProfileImgPath = () => setTempProfileImgPath(null)

    const resetSelectedServiceType = () => setSelectedServiceType(null)


    if (isLoading || fetchProfile.status === ProfileStatus.GUEST || error) {
        return <></>
    }

    if (selectedServiceType != null) {
        return <ContactEdit
            serviceType={selectedServiceType}
            close={resetSelectedServiceType}
            contactsUpdater={contactsUpdater}/>
    }

    if (tempProfileImgPath != null) {
        return <ImageCropper imagePath={tempProfileImgPath}
                             close={resetTempProfileImgPath}
                             setCroppedImage={profileUpdater.setProfileImage}/>
    }

    return <ProfileInfoEdit
        link={fetchProfile.profileLink}
        openProfileImageCropPage={setTempProfileImgPath}
        openContactEditPage={setSelectedServiceType}
        profileUpdater={profileUpdater}
        contactsUpdater={contactsUpdater}
        buildFormData={buildFormData}
        isChanged={isChanged}
    />
}